import React from 'react';
import Header from '../../components/header/Header';
import Stack from '../../components/stack/Stack';
const Index = () => {
	return (
		<React.Fragment>
			<Header />
			<Stack />
		</React.Fragment>
	);
};
export default Index;
